import axios from 'axios';

// This is for the app to make general HTTP requests (including to it's own API routes)
export const appHttp = axios.create({
  timeout: 10000,
});
